import { ApiDOMError } from '@swagger-api/apidom-error';
class DereferenceError extends ApiDOMError {}
export default DereferenceError;